import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import { appendOwnerState } from "./appendOwnerState.es.js";
import { mergeSlotProps } from "./mergeSlotProps.es.js";
import { resolveComponentProps } from "./resolveComponentProps.es.js";
import useForkRef from "../node_modules/@mui/utils/useForkRef/useForkRef.es.js";
const _excluded = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(parameters) {
  var _a;
  const {
    elementType,
    externalSlotProps,
    ownerState,
    skipResolvingSlotProps = false
  } = parameters, rest = _objectWithoutPropertiesLoose(parameters, _excluded);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_a = parameters.additionalProps) == null ? void 0 : _a.ref);
  const props = appendOwnerState(elementType, _extends({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
export {
  useSlotProps
};
//# sourceMappingURL=useSlotProps.es.js.map
